import type { FieldValues, Path, UseFormSetError } from 'react-hook-form';
import { getErrorMessage, getFieldErrors } from './api';

/**
 * Aplica os erros de validação devolvidos pela API (`{message, errors:[{path,message}]}`)
 * nos campos correspondentes do formulário. Retorna a mensagem geral, quando houver
 * erro que não pertence a nenhum campo.
 */
export function applyApiErrors<T extends FieldValues>(
  error: unknown,
  setError: UseFormSetError<T>,
  knownFields?: string[],
): string | null {
  const fieldErrors = getFieldErrors(error);

  if (fieldErrors.length === 0) return getErrorMessage(error);

  let unmatched: string | null = null;

  for (const item of fieldErrors) {
    const path = item.path?.trim();
    if (!path) {
      unmatched = item.message;
      continue;
    }
    if (knownFields && !knownFields.includes(path)) {
      unmatched = unmatched ? `${unmatched} · ${item.message}` : item.message;
      continue;
    }
    setError(path as Path<T>, { type: 'server', message: item.message });
  }

  return unmatched;
}
